<template>
  <section id="admin-filter">
    <h4>Exchange Rate filter</h4>
    <div class="form-group">
      <label for="ex-filter-from" class="form-label">From currency</label>
      <select class="form-control" id="ex-filter-from" v-model="entity.fromCurrency">
        <option v-for="(opt, i) in currencies" :value="opt.id" :selected="entity.fromCurrency && entity.fromCurrency.id === opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="ex-filter-to" class="form-label">To currency</label>
      <select class="form-control" id="ex-filter-to" v-model="entity.toCurrency">
        <option v-for="(opt, i) in currencies" :value="opt.id" :selected="entity.toCurrency && entity.toCurrency.id === opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'ExchangeRateFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          fromCurrency: '',
          toCurrency: ''
        }
      }
    },
    computed: {
      currencies () {
        return this.$store.getters['systemOption/currencies']
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// ExchangeRateFilter.vue?d8e4fa9e